<script>
  import { router } from '@inertiajs/svelte'
  import { untrack } from 'svelte'
  import Layout from '../../layouts/layout.svelte'
  import ReviewSurface from '../../components/quest_submissions/review_surface.svelte'

  let {
    queue = { items: [], next_offset: 0, has_more: false, total_count: 0 },
    start_id = null,
    rejection_categories = [],
    curation_levels = [],
    exit_path = '/quest-submissions'
  } = $props()

  // The exact list-page filters (replayed via the URL this page was opened
  // with) loaded page by page and accumulated client-side, driven by Inertia
  // partial reloads (`only: ['queue']`).
  let items = $state(untrack(() => [...queue.items]))
  let loadingMore = $state(false)

  $effect(() => {
    const incoming = queue.items
    untrack(() => {
      const fresh = incoming.filter((item) => !items.some((existing) => existing.id === item.id))
      if (fresh.length > 0) items = [...items, ...fresh]
    })
  })

  const loadMore = () => {
    if (loadingMore || !queue.has_more) return
    loadingMore = true
    router.reload({ only: ['queue'], data: { after: queue.next_offset }, onFinish: () => (loadingMore = false) })
  }
</script>

<Layout>
  <ReviewSurface
    queue={{ items, totalCount: queue.total_count, hasMore: queue.has_more, loadMore }}
    startId={start_id}
    rejectionCategories={rejection_categories}
    curationLevels={curation_levels}
    exitLabel="Back to list"
    onExit={() => router.visit(exit_path)}
  />
</Layout>
